import { type OpenApiSchemaImportProductsSettings, type OpenApiSchemaMapping } from '#shared/api/schema';
import { type SupportedIntegrationSyncTypes, type SupportedIntegrationTypes } from '#shared/lib/integrations';
import { setIntegrationMappingSettings } from '../api';
import { ENDPOINT_UPDATE_INTEGRATION_SETTINGS } from '../lib/integrationSettingsUpdateEndpoints';

type UpdateIntegrationSourceSettingsParams = {
    syncType: SupportedIntegrationSyncTypes;
    source: SupportedIntegrationTypes;
    mapping: OpenApiSchemaMapping;
    createStrategy?: OpenApiSchemaImportProductsSettings['create_strategy'];
};

export const updateIntegrationSourceSettings = async ({
    syncType,
    source,
    mapping,
    createStrategy,
}: UpdateIntegrationSourceSettingsParams): Promise<void> => {
    await setIntegrationMappingSettings({
        params: { integration_type: source },
        payload: mapping,
    });

    const payload: OpenApiSchemaImportProductsSettings = {
        system_type: source,
    };

    if (syncType === 'products') {
        payload.create_strategy = createStrategy;
    }

    await ENDPOINT_UPDATE_INTEGRATION_SETTINGS[syncType](payload);
};
